//@flow

// Safari can't parse more than 3 fractional-second digits (server sends nanoseconds).
export const parseExpireAt = (value: ?string): ?number => {
  if (!value) return null;
  const trimmed = String(value).replace(/(\.\d{3})\d+/, '$1');
  // Without an offset, Date.parse would treat the server's UTC time as local time.
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/i.test(trimmed);
  const parsed = Date.parse(hasOffset ? trimmed : `${trimmed}Z`);
  return Number.isNaN(parsed) ? null : parsed;
};

// Both timestamps come from the server clock, so their difference is immune to device clock skew.
export const toLocalExpireAt = (
  expiresAt: ?string,
  generatedAt: ?string
): ?number => {
  const expires = parseExpireAt(expiresAt);
  const generated = parseExpireAt(generatedAt);
  if (!expires) return null;
  if (!generated) return expires;
  return Date.now() + Math.max(0, expires - generated);
};

export const formatRemaining = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
};
